<template>
  <div>
    <!-- 国际运费预估 -->
    <el-dialog :title="$t('message.internationalFreightEstimate')" :close-on-click-modal="false"
      :visible.sync="$parent.freightDialogVisible" width="570px" center>
      <div class="freight">
        <!-- 计算 -->
        <div class="search">
          <div class="row">
            <!-- 总体积 -->
            <div class="label">{{ $t("message.totalVolumes") }}:</div>
            <div class="input">
              <el-input v-model="val" type="number"></el-input>
            </div>
            <div class="btn"></div>
          </div>
          <div class="row">
            <!-- 总重量 -->
            <div class="label">{{ $t("message.totalWeight") }}:</div>
            <div class="input">
              <el-input v-model="val" type="number"></el-input>
            </div>
            <div class="btn">
              <!-- 重置 -->
              <el-button type="primary" class="dark">{{
                $t("message.reset")
              }}</el-button>
              <!-- 计算 -->
              <el-button type="primary">{{
                $t("message.calculate")
              }}</el-button>
            </div>
          </div>
        </div>
        <div class="table">
          <ol>
            <!-- 选择 -->
            <li class="flex05">{{ $t("message.choose") }}</li>
            <!-- 物流方式 -->
            <li>{{ $t("message.shippingMethods") }}</li>
            <!-- 预计运费 -->
            <li>{{ $t("message.estimatedShipping") }}</li>
          </ol>
          <ul>
            <!-- 选择 -->
            <li class="flex05">
              <label>
                <el-checkbox v-model="checked"></el-checkbox>
              </label>
            </li>
            <!-- 物流方式 -->
            <li>{{ $t("message.shippingMethods") }}</li>
            <!-- 预计运费 -->
            <li>{{ $t("message.estimatedShipping") }}</li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.freightDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary">{{ $t("message.save") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      optionsList: [{}, {}, {}],
      val: "",
      checked: false,
    };
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.freight {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;

  .search {
    .row {
      margin-bottom: 16px;
      display: flex;

      .label {
        flex: 0.4;
        line-height: 42px;
      }

      .input {
        flex: 1.3;
      }

      .btn {
        flex: 1;
        text-align: right;
      }
    }
  }

  .table {
    ol {
      display: flex;
      height: 40px;
      background: #edeff4;
      border-radius: 4px 4px 0px 0px;
      border: 1px solid #edeff4;
    }

    ul {
      display: flex;
      border: 1px solid #edeff4;
      border-top: 0;

      li {
        border-right: 1px solid #edeff4;

        &:nth-last-child(1) {
          border: 0;
        }
      }

      label {
        width: 100%;
        // height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 0;
      }
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .flex05 {
      flex: 0.5;
    }
  }
}
</style>